export default "__VITE_PUBLIC_ASSET__15943ba3__"